/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsAttributionShadowSummaryData
 */
export interface GoogleAnalyticsAttributionShadowSummaryData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowSummaryData
     */
    outcome?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowSummaryData
     */
    currencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleAnalyticsAttributionShadowSummaryData
     */
    orderCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowSummaryData
     */
    turnoverWithVat?: string;
}

/**
 * Check if a given object implements the GoogleAnalyticsAttributionShadowSummaryData interface.
 */
export function instanceOfGoogleAnalyticsAttributionShadowSummaryData(value: object): value is GoogleAnalyticsAttributionShadowSummaryData {
    return true;
}

export function GoogleAnalyticsAttributionShadowSummaryDataFromJSON(json: any): GoogleAnalyticsAttributionShadowSummaryData {
    return GoogleAnalyticsAttributionShadowSummaryDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowSummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAttributionShadowSummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
        'turnoverWithVat': json['turnoverWithVat'] == null ? undefined : json['turnoverWithVat'],
    };
}

export function GoogleAnalyticsAttributionShadowSummaryDataToJSON(json: any): GoogleAnalyticsAttributionShadowSummaryData {
    return GoogleAnalyticsAttributionShadowSummaryDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowSummaryDataToJSONTyped(value?: GoogleAnalyticsAttributionShadowSummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'currencyCode': value['currencyCode'],
        'orderCount': value['orderCount'],
        'turnoverWithVat': value['turnoverWithVat'],
    };
}

